/**
 * REWE Digital GmbH.
 * IT-Verticals
 *
 * zr-bannerx-wrapper component
 */

@use '../zr-theme/zr-variables.scss' as *;
@use '../zr-theme/functions/fonts' as f;

// component name
$component: 'zr-bannerx-wrapper';

// component vars defaults
:host {
    grid-row-start: 13;
    grid-column: 1 / -1;
    max-width: 100vw;
    margin-bottom: -20px;
    display: var(--zr-bannerx-display, none);

    @media only screen and (min-width: $tablet-screen) {
        grid-row-start: 4;
    }
}

.#{$component} {
    background: var(--zr-bannerx-background-color, #00859B);
    visibility: var(--zr-bannerx-visibility, hidden);
    overflow: hidden;
    position: relative;

    @media only screen and (min-width: $tablet-screen) {
        border-radius: 8px;
    }

    margin-bottom: 20px;
}

.#{$component}__content {
    padding: 0 8px 8px;
}

.#{$component}__head {
    display: flex;
    padding: 8px 0;

    .#{$component}__headline {
        color: var(--zr-bannerx-text-color, #fff);
        font-family: "Museo Sans Rounded", sans-serif;
        font-size: f.calc-em(20);
        font-weight: 600;
        line-height: 1.2em;
        margin: 8px;
        flex: 1;

        @media only screen and (min-width: $tablet-screen) {
            font-size: f.calc-em(32);
        }
    }
}
